import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-[#262626]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-20 md:py-28">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-10">
          <div>
            <span className="text-xs tracking-[0.3em] uppercase text-[#C5A059] font-['Outfit'] font-semibold block mb-4">{t("footer_tag")}</span>
            <h2 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-white leading-[1.1]">
              {t("footer_title")}<br /><span className="italic text-white/70">{t("footer_title_italic")}</span>
            </h2>
          </div>
          <a href="/#contact" data-testid="footer-request-access-btn" className="btn-primary px-10 py-4 text-xs tracking-[0.15em] uppercase font-['Outfit'] flex items-center gap-2 whitespace-nowrap">
            {t("nav_request")} <ArrowRight size={14} />
          </a>
        </div>
      </div>
      <div className="section-divider" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-1">
            <Link to="/" className="flex flex-col items-start mb-4">
              <span className="text-[#C5A059] font-semibold text-base tracking-[0.3em] uppercase font-['Outfit']">SERAVA</span>
              <span className="text-white/40 text-[9px] tracking-[0.25em] uppercase font-['Outfit'] font-light -mt-0.5">Sportsevents</span>
            </Link>
            <p className="text-white/40 font-['Outfit'] font-light text-sm leading-relaxed">{t("premium_tagline")}</p>
          </div>
          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase text-[#C5A059] font-['Outfit'] font-semibold mb-6">{t("footer_nav")}</h4>
            <ul className="space-y-3">
              {[{ label: t("nav_events"), href: "/#events" }, { label: t("nav_about"), href: "/#why-serava" }, { label: t("nav_how"), href: "/#how-it-works" }, { label: t("news_tag"), href: "/#newsletter" }].map((link) => (
                <li key={link.label}><a href={link.href} className="text-white/40 hover:text-[#C5A059] text-sm font-['Outfit'] font-light transition-colors">{link.label}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase text-[#C5A059] font-['Outfit'] font-semibold mb-6">{t("footer_company")}</h4>
            <ul className="space-y-3">
              {[
                { label: t("about_serava"), slug: "om-serava" },
                { label: t("privacy_policy"), slug: "integritetspolicy" },
                { label: t("terms_of_service"), slug: "anvandarvillkor" },
              ].map((link) => (
                <li key={link.slug}>
                  <Link to={`/p/${link.slug}`} data-testid={`footer-link-${link.slug}`} className="text-white/40 hover:text-[#C5A059] text-sm font-['Outfit'] font-light transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div id="contact">
            <h4 className="text-xs tracking-[0.2em] uppercase text-[#C5A059] font-['Outfit'] font-semibold mb-6">{t("footer_contact")}</h4>
            <ul className="space-y-3 text-white/40 font-['Outfit'] font-light text-sm">
              <li>contact@seravagroup.com</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="section-divider" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-6 flex flex-col sm:flex-row justify-between items-center gap-4">
        <p className="text-white/20 text-xs font-['Outfit'] font-light">&copy; {new Date().getFullYear()} Serava Sports AB. {t("footer_rights")}</p>
        <div className="flex gap-6">
          {[
            { label: t("privacy"), slug: "integritet" },
            { label: t("terms"), slug: "villkor" },
            { label: t("cookies"), slug: "cookies" },
          ].map((link) => (
            <Link key={link.slug} to={`/p/${link.slug}`} data-testid={`footer-bottom-link-${link.slug}`} className="text-white/20 hover:text-white/40 text-xs font-['Outfit'] font-light transition-colors">
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
}
